module.exports = __webpack_public_path__ + "assets/img/img-detail-bottom-sp.db0deb69.jpg";